module.exports = __webpack_public_path__ + "static/media/edresult1.ac0b40b9.png";